import l from "components/util/l";

export const VIEW_LABELS = {
  "main": l("Solución%PA628"),
  "brief": l("Proyecto%PA444"),
  "processes": l("Procesos%PA114"),
  "data": l("Datos%PA115"),
  "versions": l("Versiones%SA171"),
  "permissions": l("Permisos%PA107"),
  "test_cases": l("Casos de prueba%PA314"),
  "licenses": l("Licencias%PA895"),
  "settings": l("Configuración%PA119")
}

export const VIEW_ICONS = {
  "main": "fas fa-layer-group",
  "brief": "fas fa-home",
  "processes": "fas fa-project-diagram",
  "data": "fas fa-table",
  "model": "fas fa-brain",
  "settings": "fas fa-cog",
  "versions": "fas fa-code-branch",
  "permissions": "fas fa-key",
  "test_cases": "fas fa-bug",
  "licenses": "fas fa-id-card"
}

export const VIEW_ORDERS = [
  "brief",
  "main",
  "processes",
  "data",
  "permissions",
  "versions",
  "licenses"
]

export const VIEW_PERMISSION_MAP = {
  "processes": "show_processes",
  "data": "show_data",
  "history": "show_history",
  "model": "show_model",
  "settings": "show_settings",
  "permissions": "show_settings",
  "versions": "show_settings",
  "test_cases": "show_settings",
  "licenses": "show_licenses",
}

export const isCustomView = (view) =>
  !view?.is_prebuilt || (view?.name ?? "").startsWith("custom-");

export const getViewPermissionKey = (view) => {
  if (!view?.name) return null;
  if (isCustomView(view)) return "show_main";
  return VIEW_PERMISSION_MAP[view.name] || `show_${view.name}`;
}

// `is_developer` is the default answer for a role that says nothing about the view, not a
// gate above the permissions: a role explicitly granted "Mostrar sección - Proyecto" gets
// the section, which is the only thing that toggle does.
export const canShowView = (view, isDeveloper, hasPermission) => {
  if (isDeveloper) return true;
  const permissionKey = getViewPermissionKey(view);
  if (!permissionKey) return !view.is_developer;
  return hasPermission(permissionKey, null, !view.is_developer);
}
